import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "nav-icons" }
const _hoisted_3 = {
  href: "/",
  class: "icon-btn",
  "aria-label": "Home"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]

import { Github, Linkedin, Instagram, Mail, Sun, Home, Moon } from 'lucide-vue-next';
import { content } from "@/content/data"
import { useTheme } from '@/composables/useTheme'


export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const { isDark, toggleTheme } = useTheme()

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "brand-name"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(content).name), 1)
      ]),
      _: 1
    }),
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _createVNode(_unref(Home), {
          size: 20,
          "stroke-width": "1.5"
        })
      ]),
      _createElementVNode("a", {
        href: _unref(content).links.github,
        target: "_blank",
        class: "icon-btn",
        "aria-label": "GitHub"
      }, [
        _createVNode(_unref(Github), {
          size: 20,
          "stroke-width": "1.5"
        })
      ], 8, _hoisted_4),
      _createElementVNode("a", {
        href: _unref(content).links.instagram,
        target: "_blank",
        class: "icon-btn",
        "aria-label": "Instagram"
      }, [
        _createVNode(_unref(Instagram), {
          size: 20,
          "stroke-width": "1.5"
        })
      ], 8, _hoisted_5),
      _createElementVNode("a", {
        href: `mailto:${_unref(content).links.email}`,
        class: "icon-btn",
        "aria-label": "Email"
      }, [
        _createVNode(_unref(Mail), {
          size: 20,
          "stroke-width": "1.5"
        })
      ], 8, _hoisted_6),
      _createElementVNode("a", {
        href: _unref(content).links.linkedin,
        target: "_blank",
        class: "icon-btn",
        "aria-label": "LinkedIn"
      }, [
        _createVNode(_unref(Linkedin), {
          size: 20,
          "stroke-width": "1.5"
        })
      ], 8, _hoisted_7),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleTheme) && _unref(toggleTheme)(...args))),
        class: "icon-btn",
        "aria-label": "Toggle Theme"
      }, [
        (_unref(isDark))
          ? (_openBlock(), _createBlock(_unref(Sun), {
              key: 0,
              size: 18
            }))
          : (_openBlock(), _createBlock(_unref(Moon), {
              key: 1,
              size: 18
            }))
      ])
    ])
  ]))
}
}

})